/**
 * The SharePoint / Stream video embed allowlist, on its own so a page can use
 * it without loading the Academy block renderer (Vera Home's Spotlight does).
 */

/** Embeddable URL for Microsoft video links, or null when it's a normal link. */
export function videoEmbedUrl(href: string): string | null {
  let u: URL;
  try {
    u = new URL(href);
  } catch {
    return null;
  }
  if (u.protocol !== 'https:') return null;
  const host = u.hostname.toLowerCase();
  if (host === 'web.microsoftstream.com' || host.endsWith('.microsoftstream.com')) {
    const m = u.pathname.match(/^\/video\/([0-9a-f-]+)/i);
    if (m) return `https://${host}/embed/video/${m[1]}`;
    if (u.pathname.startsWith('/embed/')) return href;
    return null;
  }
  if (host.endsWith('.sharepoint.com')) {
    if (u.pathname.includes('/_layouts/15/embed.aspx')) return href;
    if (u.pathname.includes('/_layouts/15/stream.aspx')) return href;
    if (u.pathname.startsWith('/:v:')) return href;
    return null;
  }
  return null;
}
